import { createFeatureSelector } from '@ngrx/store';

export const creditCardsState = createFeatureSelector<OLO.State, OLO.State.CreditCards>('creditCards');
